const React = require('react');
const ReactIntl = require('react-intl');
const _ = require('lodash');

const { Input, Button, Layout, Text, Modal, ModalContent, ModalHeader, Separator } = require('@metro-ui/core');

const LoginActions = require('../../actions/LoginActions.js');
const defaultMessages = require('../../i18n/messages/default');

const { injectIntl } = ReactIntl;

class EditAuthModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authenticationMethodName: ''
        };
    }

    setAuthenticationMethodName(value) {
        this.setState({authenticationMethodName : value})
    }

    onSave() {
        const {credentialId, tokenId, userType, userId, countryCode, name} = this.props;

        const {authenticationMethodName} = this.state;
        const payload = {isDefault: true, name: authenticationMethodName, remarks:''};
        if(authenticationMethodName) {
            LoginActions.changeUserMFAMethod(tokenId, userId, userType, credentialId, payload, countryCode);
        }
        this.props.closeModal()
    }

    render() {
        const { intl, closeModal, name } = this.props;
        return (
            <div className='editAuthMethods-modal'>
            <Modal
                aria-labelledby="modal-title"
                isOpen
                onDismiss={() => {
                    closeModal();
                }}
            >
                <ModalHeader
                    align="end"
                    isClosable
                    padding="medium"
                    spacing="medium"
                >
                    {intl.formatMessage(defaultMessages['loginpreferences.2famethods.edit'])}
                </ModalHeader>
                <ModalContent
                    direction="column"
                    padding="xx-large"
                    spacing="medium"
                    className='edit-modal'
                >
                    <strong>{intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.edit'])}</strong>
                    <Text className="margin-bottom-small" size="medium">
                      {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.add'])}
                    </Text>
                    <Input 
                      defaultValue={name}
                      onChange={(_, value) => this.setAuthenticationMethodName(value)}
                    />
                    <Separator/>
                    <Layout direction='row' className='footer-section' >
                        <Text
                            className='underline-text'
                            onClick={() => {
                                closeModal();
                                this.clear()
                            }}
                        >
                            {intl.formatMessage(defaultMessages['cancel'])}
                        </Text>
                        <Button isWide
                            size='medium'
                            isFullWidth={false}
                            variant='primary'
                            onClick={()=>this.onSave()}
                            >
                            {intl.formatMessage(defaultMessages['save'])}
                        </Button>
                    </Layout>
                </ModalContent>
            </Modal>
            </div>
        );
    }
}

module.exports = injectIntl(EditAuthModal);